import { type LabelHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export function Label({ className, ...rest }: LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn('text-xs font-medium text-muted-foreground', className)} {...rest} />;
}
